module.exports = __webpack_public_path__ + "static/media/corporate-services-img70.ab106365.jpg";